// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3J23u","tab":"Tabs_tab__1EDW_","tabActive":"Tabs_tabActive__h0TNM"};